import { DocumentIcon } from '@heroicons/react/24/outline'
import type { MapperConfig } from '../mapperConfigs'

export const masterList: MapperConfig = {
  name: 'Master Parts List',
  type: 'Upload',
  orgIds: ['shaper'],
  rootIsTopLevel: true,
  Logo: DocumentIcon,
  rowsToBom: [{
    type: 'FilterRemove',
    config: {
      conditions: [{
        type: 'regex',
        column: 'subpart',
        value: 'T',
      }]
    }
  }, {
    type: 'FilterRemove',
    config: {
      conditions: [{
        type: 'regex',
        column: 'shipping_lt',
        value: '[^0-9.]',
      }]
    }
  }],
  importOutputFields: {
    metadata: [
      'festool-pn',
      '2-d-ownership',
      'mp-design-status',
      'drawing-status',
      'dfm-status',
      'release-readiness',
      'in-en-sku',
      'in-nn-sku',
      'in-sn-sku',
      'in-un-sku',
      'in-on-sku',
      'po',
      'moq',
      'type',
      'vendor',
      'tooling',
      'incoterm',
      'location',
      'festool-avl',
      'shipping-lt',
      'quote-status',
      'release-date',
      'extended-cost',
      'shipping-status',
      'who-place-the-po',
      "lt-weeks-w-o-shipping",
      "release-status-to-vendor",
      "part-cost-incl-vat-excl-duty-tax",
    ]
  },
  standardizeBom: {
    columns: {
      metadata: {
        'festool-pn': {
          value: '{{row.festool_pn}}',
          type: 'simple'
        },
        '2-d-ownership': {
          value: '{{row.2_d_ownership}}',
          type: 'simple'
        },
        'mp-design-status': {
          value: '{{row.mp_design_status}}',
          type: 'simple'
        },
        'drawing-status': {
          value: '{{row.drawing_status}}',
          type: 'simple'
        },
        'dfm-status': {
          value: '{{row.dfm_status}}',
          type: 'simple'
        },
        'release-readiness': {
          value: '{{row.release_readiness}}',
          type: 'simple'
        },
        'in-en-sku': {
          value: '{{row.en}}',
          type: 'simple'
        },
        'in-on-sku': {
          value: '{{row.on}}',
          type: 'simple'
        },
        'in-nn-sku': {
          value: '{{row.nn}}',
          type: 'simple'
        },
        'in-un-sku': {
          value: '{{row.un}}',
          type: 'simple'
        },
        'in-sn-sku': {
          value: '{{row.sn}}',
          type: 'simple'
        },
        'po': {
          value: '{{row.po}}',
          type: 'simple'
        },
        'moq': {
          value: '{{row.moq}}',
          type: 'simple'
        },
        'type': {
          value: '{{row.type}}',
          type: 'simple'
        },
        'vendor': {
          value: '{{row.vendor}}',
          type: 'simple'
        },
        'tooling': {
          value: '{{row.tooling}}',
          type: 'simple'
        },
        'incoterm': {
          value: '{{row.incoterm}}',
          type: 'simple'
        },
        'location': {
          value: '{{row.location}}',
          type: 'simple'
        },
        'festool-avl': {
          value: '{{row.festool_avl}}',
          type: 'simple'
        },
        'shipping-lt': {
          value: '{{row.shipping_lt}}',
          type: 'simple'
        },
        'quote-status': {
          value: '{{row.quote_status}}',
          type: 'simple'
        },
        'release-date': {
          value: '{{row.release_date}}',
          type: 'simple'
        },
        'extended-cost': {
          value: '{{row.extended_cost}}',
          type: 'simple'
        },
        'shipping-status': {
          value: '{{row.shipping_status}}',
          type: 'simple'
        },
        'who-place-the-po': {
          value: '{{row.who_place_the_po}}',
          type: 'simple'
        },
        'lt-weeks-w-o-shipping': {
          value: '{{row.lt_weeks_w_o_shipping}}',
          type: 'simple'
        },
        'release-status-to-vendor': {
          value: '{{row.release_status_to_vendor}}',
          type: 'simple'
        },
        'part-cost-incl-vat-excl-duty-tax': {
          value: '{{row.part_cost_incl_vat_excl_duty_tax}}',
          type: 'simple'
        }
      },
      summary: {
        type: 'ignore'
      },
      quantity: {
        value: '1',
        type: 'simple'
      },
      units: {
        value: 'each',
        type: 'simple'
      },
      categoryId: {
        value: '{{row.category_id}}',
        type: 'simple'
      },
      isOffTheShelf: {
        type: 'simple',
        value: 'subpart'
      },
      hierarchy: {
        value: '{{row.hierarchy}}',
        type: 'simple'
      },
      partNumber: {
        value: '{{row.shaper_pn}}',
        type: 'simple'
      },
      name: {
        value: '{{row.description}}',
        type: 'simple'
      },
      cadRev: {
        value: '{{row.rev}}',
        type: 'simple'
      }
    }
  }
}

export const bom: MapperConfig = {
  name: 'Structured BOM',
  type: 'Upload',
  orgIds: ['shaper'],
  rootIsTopLevel: true,
  Logo: DocumentIcon,
  importOutputFields: {
    metadata: []
  },
  standardizeBom: {
    columns: {
      summary: {
        type: 'ignore'
      },
      quantity: {
        value: '{{row.qty}}',
        type: 'simple'
      },
      units: {
        value: 'each',
        type: 'simple'
      },
      name: {
        value: '{{row.name}}',
        type: 'simple'
      },
      categoryId: {
        value: 'other',
        type: 'simple'
      },
      isOffTheShelf: {
        type: 'ignore'
      },
      hierarchy: {
        value: '{{row.hierarchy}}',
        type: 'simple'
      },
      partNumber: {
        value: '{{row.part_number}}',
        type: 'simple'
      },
      referenceDesignator: {
        value: '{{row.refdes}}',
        type: 'simple'
      },
    }
  }
}
